var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58 10.8895L7.35 6.81953C7.91 6.41953 7.91 5.57953 7.35 5.18953L1.58 1.10953C0.91 0.649534 0 1.11953 0 1.92953V10.0695C0 10.8795 0.91 11.3495 1.58 10.8895ZM9 1.92953V10.0695C9 10.8795 9.91 11.3495 10.58 10.8895L16.35 6.81953C16.91 6.41953 16.91 5.57953 16.35 5.18953L10.58 1.11953C9.91 0.649533 9 1.11953 9 1.92953Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowIcon);
export default __webpack_public_path__ + "static/media/DoubleArrowIcon.832d907f3bf93eeec84013eca88ac802.svg";
export { ForwardRef as ReactComponent };